module.exports = __webpack_public_path__ + "static/media/home.6fb21713.jpg";